import React, { useState, useEffect, useRef } from 'react'
import { Input, Button, InputRef } from 'antd'
import { Pencil } from 'lucide-react'
import type { LineItem } from '../../types/ffe'

interface Props {
  item: LineItem
  onUpdate: (updates: Partial<LineItem>) => void
}

export const LineItemCode: React.FC<Props> = ({ item, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [tempValue, setTempValue] = useState(item.code)
  const inputRef = useRef<InputRef>(null)

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [isEditing])

  useEffect(() => {
    setTempValue(item.code)
  }, [item.code])

  const handleSubmit = () => {
    onUpdate({ code: tempValue.toUpperCase() })
    setIsEditing(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    } else if (e.key === 'Escape') {
      setTempValue(item.code)
      setIsEditing(false)
    }
  }

  if (isEditing) {
    return (
      <Input
        ref={inputRef}
        value={tempValue}
        placeholder="Code"
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleSubmit}
        onKeyDown={handleKeyDown}
        className="w-[80px] text-sm"
      />
    )
  }

  return (
    <Button
      type="text"
      className="h-auto py-1 px-2 hover:bg-gray-50 text-left justify-start flex"
      onClick={() => setIsEditing(true)}
    >
      <div className="flex items-center gap-1">
        <span className="flex-1 font-mono text-sm">
          {item.code || <span className="text-gray-400">{'Code'}</span>}
        </span>
        <Pencil className="h-3 w-3 text-gray-400 flex-shrink-0" />
      </div>
    </Button>
  )
}
